module.exports = __webpack_public_path__ + "3c7fea819acfd022d1cbed698437b919.woff2";


//////////////////
// WEBPACK FOOTER
// ./assets/fonts/Lato-BoldItalic.woff2
// module id = 720
// module chunks = 0